function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { PicturePattern } from "../render/patterns/PicturePattern";
import { Sprite } from "./Sprite";
import { BlendMode } from "./backend/Renderer";
import * as $type from "../util/Type";
import * as $array from "../util/Array";
export var visualSettings = ["fill", "fillOpacity", "stroke", "strokeWidth", "strokeOpacity", "fillPattern", "strokePattern", "fillGradient", "strokeGradient", "strokeDasharray", "strokeDashoffset"];
/**
 * Base class used for drawing shapes.
 *
 * @see {@link https://www.amcharts.com/docs/v5/concepts/common-elements/graphics/} for more info
 * @important
 */
export var Graphics = /*#__PURE__*/function (_Sprite) {
  _inherits(Graphics, _Sprite);
  var _super = _createSuper(Graphics);
  function Graphics() {
    var _this;
    _classCallCheck(this, Graphics);
    _this = _super.apply(this, arguments);
    Object.defineProperty(_assertThisInitialized(_this), "_display", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this._root._renderer.makeGraphics()
    });
    Object.defineProperty(_assertThisInitialized(_this), "_clear", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    return _this;
  }
  _createClass(Graphics, [{
    key: "_beforeChanged",
    value: function _beforeChanged() {
      var _this2 = this;
      _get(_getPrototypeOf(Graphics.prototype), "_beforeChanged", this).call(this);
      if (this.isDirty("draw") || this.isDirty("svgPath")) {
        this.markDirtyBounds();
      }
      if (this.isDirty("fill") || this.isDirty("stroke") || this.isDirty("visible") || this.isDirty("forceHidden") || this.isDirty("scale") || this.isDirty("fillGradient") || this.isDirty("strokeGradient") || this.isDirty("fillPattern") || this.isDirty("strokePattern") || this.isDirty("fillOpacity") || this.isDirty("strokeOpacity") || this.isDirty("strokeWidth") || this.isDirty("draw") || this.isDirty("blendMode") || this.isDirty("strokeDasharray") || this.isDirty("strokeDashoffset") || this.isDirty("svgPath") || this.isDirty("lineJoin") || this.isDirty("shadowColor") || this.isDirty("shadowBlur") || this.isDirty("shadowOffsetX") || this.isDirty("shadowOffsetY")) {
        this._clear = true;
      }
      this._display.crisp = this.get("crisp", false);
      if (this.isDirty("fillGradient")) {
        var gradient = this.get("fillGradient");
        if (gradient) {
          this._display.isMeasured = true;
          var gradientTarget = gradient.get("target");
          if (gradientTarget) {
            this._disposers.push(gradientTarget.events.on("boundschanged", function () {
              _this2._markDirtyKey("fill");
            }));
            this._disposers.push(gradientTarget.events.on("positionchanged", function () {
              _this2._markDirtyKey("fill");
            }));
          }
        }
      }
      if (this.isDirty("strokeGradient")) {
        var _gradient = this.get("strokeGradient");
        if (_gradient) {
          this._display.isMeasured = true;
          var _gradientTarget = _gradient.get("target");
          if (_gradientTarget) {
            this._disposers.push(_gradientTarget.events.on("boundschanged", function () {
              _this2._markDirtyKey("stroke");
            }));
            this._disposers.push(_gradientTarget.events.on("positionchanged", function () {
              _this2._markDirtyKey("stroke");
            }));
          }
        }
      }
    }
  }, {
    key: "_changed",
    value: function _changed() {
      _get(_getPrototypeOf(Graphics.prototype), "_changed", this).call(this);
      if (this._clear) {
        this.markDirtyBounds();
        this.markDirtyLayer();
        this._display.clear();
        var strokeDasharray = this.get("strokeDasharray");
        if ($type.isNumber(strokeDasharray)) {
          if (strokeDasharray < 0.5) {
            strokeDasharray = [0];
          } else {
            strokeDasharray = [strokeDasharray];
          }
        }
        this._display.setLineDash(strokeDasharray);
        var strokeDashoffset = this.get("strokeDashoffset");
        if (strokeDashoffset) {
          this._display.setLineDashOffset(strokeDashoffset);
        }
        var blendMode = this.get("blendMode", BlendMode.NORMAL);
        this._display.blendMode = blendMode;
        var draw = this.get("draw");
        if (draw) {
          draw(this._display, this);
        }
        var svgPath = this.get("svgPath");
        if (svgPath != null) {
          this._display.svgPath(svgPath);
        }
      }
    }
  }, {
    key: "_afterChanged",
    value: function _afterChanged() {
      var _this3 = this;
      _get(_getPrototypeOf(Graphics.prototype), "_afterChanged", this).call(this);
      if (this._clear) {
        var fill = this.get("fill");
        var fillGradient = this.get("fillGradient");
        var fillPattern = this.get("fillPattern");
        var fillOpacity = this.get("fillOpacity");
        var stroke = this.get("stroke");
        var strokeGradient = this.get("strokeGradient");
        var strokePattern = this.get("strokePattern");
        var shadowColor = this.get("shadowColor");
        var shadowBlur = this.get("shadowBlur");
        var shadowOffsetX = this.get("shadowOffsetX");
        var shadowOffsetY = this.get("shadowOffsetY");
        var shadowOpacity = this.get("shadowOpacity");
        //const bounds = this._display.getLocalBounds();
        if (shadowColor && (shadowBlur || shadowOffsetX || shadowOffsetY)) {
          this._display.shadow(shadowColor, shadowBlur, shadowOffsetX, shadowOffsetY, shadowOpacity);
        }
        if (fillPattern) {
          var changed = false;
          if (fill && (!fillPattern.get("fill") || fillPattern.get("fillInherited"))) {
            fillPattern.set("fill", fill);
            fillPattern.set("fillInherited", true);
            changed = true;
          }
          if (stroke && (!fillPattern.get("color") || fillPattern.get("colorInherited"))) {
            fillPattern.set("color", stroke);
            fillPattern.set("colorInherited", true);
            changed = true;
          }
          if (changed) {
            // @todo: is this OK?
            fillPattern._changed();
          }
          var pattern = fillPattern.pattern;
          if (pattern) {
            this._display.beginFill(pattern, fillOpacity);
            this._display.endFill();
            if (fillPattern instanceof PicturePattern) {
              fillPattern.events.once("loaded", function () {
                _this3._clear = true;
                _this3.markDirty();
              });
            }
          }
        } else if (fillGradient) {
          if (fill) {
            var stops = fillGradient.get("stops", []);
            if (stops.length) {
              $array.each(stops, function (stop) {
                if ((!stop.color || stop.colorInherited) && fill) {
                  stop.color = fill;
                  stop.colorInherited = true;
                }
                if (stop.opacity == null || stop.opacityInherited) {
                  stop.opacity = fillOpacity;
                  stop.opacityInherited = true;
                }
              });
            }
          }
          var gradient = fillGradient.getFill(this);
          if (gradient) {
            this._display.beginFill(gradient, fillOpacity);
            this._display.endFill();
          }
        } else if (fill) {
          this._display.beginFill(fill, fillOpacity);
          this._display.endFill();
        }
        if (stroke || strokeGradient || strokePattern) {
          var strokeOpacity = this.get("strokeOpacity");
          var strokeWidth = this.get("strokeWidth", 1);
          if (this.get("nonScalingStroke")) {
            strokeWidth = strokeWidth / this.get("scale", 1);
          }
          if (this.get("crisp")) {
            strokeWidth /= this._root._renderer.resolution;
          }
          var lineJoin = this.get("lineJoin");
          if (strokePattern) {
            var _changed2 = false;
            if (stroke && (!strokePattern.get("color") || strokePattern.get("colorInherited"))) {
              strokePattern.set("color", stroke);
              strokePattern.set("colorInherited", true);
              _changed2 = true;
            }
            if (_changed2) {
              // @todo: is this OK?
              strokePattern._changed();
            }
            var _pattern = strokePattern.pattern;
            if (_pattern) {
              this._display.lineStyle(strokeWidth, _pattern, strokeOpacity, lineJoin);
              this._display.endStroke();
              if (strokePattern instanceof PicturePattern) {
                strokePattern.events.once("loaded", function () {
                  _this3._clear = true;
                  _this3.markDirty();
                });
              }
            }
          } else if (strokeGradient) {
            var _stops = strokeGradient.get("stops", []);
            if (_stops.length) {
              $array.each(_stops, function (stop) {
                if ((!stop.color || stop.colorInherited) && stroke) {
                  stop.color = stroke;
                  stop.colorInherited = true;
                }
                if (stop.opacity == null || stop.opacityInherited) {
                  stop.opacity = strokeOpacity;
                  stop.opacityInherited = true;
                }
              });
            }
            var _gradient2 = strokeGradient.getFill(this);
            if (_gradient2) {
              this._display.lineStyle(strokeWidth, _gradient2, strokeOpacity, lineJoin);
              this._display.endStroke();
            }
          } else if (stroke) {
            this._display.lineStyle(strokeWidth, stroke, strokeOpacity, lineJoin);
            this._display.endStroke();
          }
        }
      }
      this._clear = false;
    }
  }]);
  return Graphics;
}(Sprite);
Object.defineProperty(Graphics, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Graphics"
});
Object.defineProperty(Graphics, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Sprite.classNames.concat([Graphics.className])
});